// Labels from the voice agent demo's onboarding panel
// (karehero-voice-agent: src/components/voice-agents/livekit/OnboardingSummary.tsx).

export type DemoStep =
  | 'care_situation'
  | 'recipient_details'
  | 'care_timing'
  | 'contact'
  | 'complete';

export const STEP_LABELS: Record<DemoStep, string> = {
  care_situation: 'Your situation',
  recipient_details: 'About them',
  care_timing: 'When help is needed',
  contact: 'Contact details',
  complete: 'Complete',
};

export const STEP_ORDER: DemoStep[] = [
  'care_situation',
  'recipient_details',
  'care_timing',
  'contact',
];

export type DemoField =
  | 'caringFor'
  | 'caringInvolves'
  | 'helpWith'
  | 'livesIn'
  | 'age'
  | 'disability'
  | 'needsHelp'
  | 'phone';

export const FIELD_LABELS: Record<DemoField, string> = {
  caringFor: 'Caring for',
  caringInvolves: 'Caring involves',
  helpWith: 'Help with',
  livesIn: 'Lives in',
  age: 'Age',
  disability: 'Disability or long-term illness',
  needsHelp: 'Needs help',
  phone: 'Phone',
};

export const DEMO_COPY = {
  title: 'Onboarding',
  notAnswered: 'Not answered',
  idle: 'Start a call to talk or type to the agent.',
  ended: 'The call has ended — click any answer to correct it.',
  inputIdle: 'Start a call to chat',
  inputLive: 'Type a message…',
  startCall: 'Start call',
  endCall: 'End call',
};
